import * as React from 'react';

import {Button, Form, Input, Select} from 'antd';

import Firebase, {withFirebase} from '../../components/Firebase';
import {FormStates} from '../../components/FormModal/FormWrapper';
import YearSelect from '../../components/FormSelects/YearSelect';
import SemesterSelect from '../../components/FormSelects/SemesterSelect';

import {IProfessor} from '../../model/Professor';
import {ICourseFeedback} from '../../model/CourseFeedback';

const Option = Select.Option;
const {TextArea} = Input;


interface IProps {
  firebase: Firebase;
  courseSlug: string;
  form: any;
  onFormStateChange: (formState: FormStates, message: string) => {}
}

interface IState {
  professors: IProfessor[];
}

class FeedbackForm extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      professors: []
    };

  }

  handleSubmit = (e: any) => {
    e.preventDefault();

    this.props.form.validateFields((err: any, values: ICourseFeedback) => {
      if (!err) {
        // store only fields that are provided
        const feedback: ICourseFeedback = {
          difficulty: values.difficulty,
          usefulness: values.usefulness,
          createdAt: this.props.firebase.serverTimestamp()
        };
        values.grade !== '' ? feedback.grade = values.grade : null;
        values.year !== -1 ? feedback.year = values.year : null;
        values.semester !== '' ? feedback.semester = values.semester : null;
        values.feedbackText !== '' ? feedback.feedbackText = values.feedbackText : null;

        this.props.firebase.createFeedback(feedback, this.props.courseSlug)
          .then((docRef) => {
            this.props.onFormStateChange(FormStates.success, 'Thank you for your feedback, it will appear after page refresh. +10 to your karma');
          }).catch((error) => {
            this.props.onFormStateChange(FormStates.error, 'Ups, something bad happened, please try again');
          });
      }
    });

  };


  public render() {
    const { getFieldDecorator } = this.props.form;

    return (
        <div>
          <Form
            onSubmit={this.handleSubmit}>

            <Form.Item label='How difficult the course was?'>
              {getFieldDecorator('difficulty', {
                rules: [{
                  required: true, message: 'Please rate difficulty of the course',
                }]
              })(
                <Select placeholder="Difficulty">
                  <Option value={5}>5: You are crazy if you pass it</Option>
                  <Option value={4}>4: No Life</Option>
                  <Option value={3}>3: You have to do something</Option>
                  <Option value={2}>2: Come to lectures</Option>
                  <Option value={1}>1: Easy A</Option>
                </Select>
              )}
            </Form.Item>

            <Form.Item label='How useful the course was?'>
              {getFieldDecorator('usefulness', {
                rules: [{
                  required: true, message: 'Please rate usefulness of the course'
                }]
              })(
                <Select placeholder="Usefullnes">
                  <Option value={5}>5: Ready to conquer the world</Option>
                  <Option value={4}>4: My life never gonna be same</Option>
                  <Option value={3}>3: Hmm, something was useful</Option>
                  <Option value={2}>2: Mostly waste of time</Option>
                  <Option value={1}>1: Omg, please give me back my time</Option>
                </Select>
              )}

            </Form.Item>

            <Form.Item label='What was your grade?'>
              {getFieldDecorator('grade', {
                initialValue: ''
              })(
                <Select placeholder='Grade'>
                  <Option value=''>Not selected</Option>
                  <Option value='A'>A</Option>
                  <Option value='A-'>A-</Option>
                  <Option value='B+'>B+</Option>
                  <Option value='B'>B</Option>
                  <Option value='B-'>B-</Option>
                  <Option value='C+'>C+</Option>
                  <Option value='C'>C</Option>
                  <Option value='C-'>C-</Option>
                  <Option value='D+'>D+</Option>
                  <Option value='D'>D</Option>
                  <Option value='F'>F</Option>
                </Select>
              )}

            </Form.Item>

            <YearSelect getFieldDecorator={getFieldDecorator}/>

            <SemesterSelect getFieldDecorator={getFieldDecorator} />

            <Form.Item label='Feedback text'>
              {getFieldDecorator('feedbackText', {
                initialValue: ''
              })(
                <TextArea rows={4} />
              )}
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
    );

  }

}
export default Form.create<IProps>()(withFirebase(FeedbackForm));
